module.exports = __webpack_public_path__ + "img/star-5.0ca44205.svg";